
import { Component, Vue } from 'vue-property-decorator';

import Form14ProcessHeader from "@/components/process/Form14/components/Form14ProcessHeader.vue";
import Form14CaseInformation from "@/components/process/Form14/components/Form14CaseInformation.vue";
import { form14StatusInfoType } from '@/types/Information/Form14';

@Component({
    components:{
        Form14ProcessHeader,
        Form14CaseInformation
    }
})
export default class StartForm14 extends Vue {

    stepsCompleted = {} as form14StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
